import { SET_NEW_USER_IS_ACTIVATED_EP } from 'services/constants';
import { tokenAuthApiInstanceWithToken } from 'utils/auth';

// this is for a new user who has registered through the sign up flow, send this flag but to EHR
// that the user is activated
export const postUserActivatedRequest = async (token: string): Promise<string[]> => {
  const response = await tokenAuthApiInstanceWithToken(token).authAxios().post(SET_NEW_USER_IS_ACTIVATED_EP);
  return response.data;
};
